import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { dark as darkColors, secondary } from 'shared/theme/colorTokens';
import { ChoferPartialModel } from 'app/chofer/models/Chofer';
import { DomicilioModel } from 'app/domicilio/models/DomicilioModel';
import { Moment } from 'moment';
import React from 'react';
import LocationDetails from './LocationDetails';
import { Dialog } from '@material-ui/core';
import { useThemeContext } from 'shared/context/themeContext';

interface Props {
  isOpen: boolean;
  handleClose: () => void;
  reservation: {
    reservationDatetime: Moment;
    arrivalDateTime: Moment;
    advanceHours: number;
    preAssignedDriver?: Pick<ChoferPartialModel, 'codigo' | 'nombreCompleto'> | null;
    client: {
      name: string;
    };
    locations: {
      address: DomicilioModel;
      observation: string;
      passengers: {
        name: string;
        phone: string | null;
      }[];
    }[];
    estimated_prices?: {
      kilometers: number;
    } | null;
  };
  footer?: React.ReactNode;
}

const ViajeTrasladoResumenModal = ({
  isOpen,
  handleClose,
  reservation,
  footer
}: Props) => {
  const { theme } = useThemeContext();
  const isDark = theme === 'dark';
  const data = {
    ...reservation,
    schedule: {
      arrival: reservation.reservationDatetime,
      exit: reservation.reservationDatetime
        .clone()
        .add(-reservation.advanceHours, 'hours'),
      end: reservation.arrivalDateTime
    }
  };
  return (
      <Dialog
      open={isOpen}
      onClose={handleClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        style: {
          backgroundColor: isDark ? darkColors.surface : secondary[100],
          borderRadius: '15px',
        }
      }}
    >
        <div>
          <div className="px-8 pt-4 " style={{ borderRadius: '15px'}}>
            <LocationDetails locations={data.locations} />
            <div className="flex justify-center space-x-16 mt-8 border-gray-200 border-dashed border-t-2  pt-8  ">
              <div className="flex space-x-4 mb-8">
                <div>
                  <p className="title col-span-1 mr-2 text-ink dark:text-ink-dark">
                    {data.schedule.exit.format('HH:mm')}
                  </p>
                  <p className="text-xs text-gray-400 col-span-1 text-ink dark:text-ink-dark">
                    {data.schedule.exit.format('DD/MM')}
                  </p>
                </div>
                <FontAwesomeIcon
                  icon={faArrowRight}
                  className="text-ink dark:text-ink-dark"
                />
                <div>
                  <p className="title col-span-1 mr-2 text-ink dark:text-ink-dark">
                    {data.schedule.arrival.format('HH:mm')}
                  </p>
                  <p className="text-xs text-gray-400 col-span-1 text-ink dark:text-ink-dark">
                    {data.schedule.arrival.format('DD/MM')}
                  </p>
                </div>
                <FontAwesomeIcon
                  icon={faArrowRight}
                  className="text-ink dark:text-ink-dark"
                />
                <div>
                  <p className="title col-span-1 mr-2 text-ink dark:text-ink-dark">
                    {data.schedule.end.format('HH:mm')}
                  </p>
                  <p className="text-xs text-gray-400 col-span-1 text-ink dark:text-ink-dark">
                    {data.schedule.end.format('DD/MM')}
                  </p>
                </div>
              </div>
              {data.preAssignedDriver && (
                <div className="flex flex-col items-center">
                  <span className="text-ink dark:text-ink-dark">
                    #{data.preAssignedDriver.codigo} -{' '}
                    {data.preAssignedDriver.nombreCompleto}
                  </span>
                  <span className="text-xs text-ink dark:text-ink-dark">
                    Chofer pre-asignado
                  </span>
                </div>
              )}
              {data.estimated_prices ? (
                <div className="flex flex-col items-center">
                  <span className="text-ink dark:text-ink-dark">
                    {data.estimated_prices.kilometers} km.
                  </span>
                  <span className="text-xs text-ink dark:text-ink-dark">
                    Estimación
                  </span>
                </div>
              ) : null}
            </div>
          </div>
          {footer}
        </div>
    </Dialog>
  );
};

export default ViajeTrasladoResumenModal;
